<template>
  <el-card class="box-card">
    <div slot="header" class="clearfix">
      <span style="font-weight: bold;"><i class="el-icon-s-custom text-blue" style="margin-right: 5px;"></i>客户分店统计</span>
      <i :class="isExpanded ? 'el-icon-arrow-down' : 'el-icon-arrow-right'" class="expand-icon" @click="toggleExpand"></i>
    </div>

    <div v-show="isExpanded" v-loading="loading" class="table-container">
      <el-table :data="customerList" border stripe style="width: 100%" height="400px">
        <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
        <el-table-column prop="name" label="客户名称" min-width="200"></el-table-column>
        <el-table-column prop="totalStoreCount" label="门店总数" width="120" align="center" sortable>
          <template slot-scope="scope">
            <span style="font-weight: bold; color: #409EFF;">{{ scope.row.totalStoreCount }}</span>
          </template>
        </el-table-column>
        <el-table-column label="品牌分布" min-width="300">
          <template slot-scope="scope">
            <el-tag
              v-for="(count, brand) in scope.row.brandStoreCount"
              :key="brand"
              size="small"
              style="margin-right: 5px; margin-bottom: 5px;"
            >
              {{ brand }}: {{ count }}家
            </el-tag>
          </template>
        </el-table-column>
      </el-table>
      <div v-if="customerList.length === 0" class="empty-text">
        暂无数据
      </div>
    </div>
  </el-card>
</template>

<script>
export default {
  name: 'CustomerStoreStatistics',
  props: {
    url: {
      type: String,
      default: 'zhaoshang/zongjian/customerStoreStatistics'
    }
  },
  data () {
    return {
      isExpanded: true,
      loading: false,
      customerList: []
    }
  },
  created () {
    this.fetchData()
  },
  methods: {
    toggleExpand () {
      this.isExpanded = !this.isExpanded
    },
    async fetchData () {
      this.loading = true
      try {
        const { data: res } = await this.$http.get(this.url)

        if (res.meta.status === 200) {
          this.customerList = res.data.customer || []
        } else {
          this.$message.error(res.meta.msg)
        }
      } catch (error) {
        console.error(error)
        this.$message.error('获取客户分店统计失败')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.text-blue { color: #409EFF; }
.clearfix {
  position: relative;
}
.expand-icon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  font-size: 16px;
  color: #909399;
  transition: all 0.3s;
}
.expand-icon:hover {
  color: #409EFF;
}
.table-container {
  padding: 10px 0;
}
.empty-text {
  text-align: center;
  padding: 40px 0;
  color: #909399;
}
</style>
